import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Home from './containers/Home';
import NotFound from './containers/NotFound';
import Login from './containers/Login';
import AppliedRoute from './components/AppliedRoute';
import Register from './containers/Register';
import NewEstimate from './containers/NewEstimate';
import Estimates from './containers/Estimates';
import AuthenticatedRoute from './components/AuthenticatedRoute';
import UnauthenticatedRoute from './components/UnauthenticatedRoute';
import Landing from './containers/Landing';
import Blog from './containers/Blog';
import Upgrade from './containers/Upgrade';

export default ({ childProps }) => (
  <Switch>
    <AppliedRoute path="/" exact component={Landing} props={childProps} />
    <AppliedRoute path="/beta" exact component={Home} props={childProps} />
    <AppliedRoute path="/blog" exact component={Blog} props={childProps} />
    <UnauthenticatedRoute
      path="/login"
      exact
      component={Login}
      props={childProps}
    />
    <UnauthenticatedRoute
      path="/register"
      exact
      component={Register}
      props={childProps}
    />
    <AuthenticatedRoute
      path="/estimates/new"
      exact
      component={NewEstimate}
      props={childProps}
    />
    <AuthenticatedRoute
      path="/estimates/:id"
      exact
      component={Estimates}
      props={childProps}
    />
    <AuthenticatedRoute
      path="/upgrade"
      exact
      component={Upgrade}
      props={childProps}
    />

    {/* Finally, catch all unmatched routes */}
    <Route component={NotFound} />
  </Switch>
);



// WEBPACK FOOTER //
// ./src/Routes.js